import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import cjson from 'compressed-json';



@Component({
    selector: 'app-diversity-tab',
    templateUrl: './diversity-tab.component.html',
    styleUrls: ['./diversity-tab.component.scss'],
    standalone: false
})
export class DiversityTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService,
    private fusionChartService: FusionChartsService
  ) { }
  companyDetails: any;
  currentCompanyName: string;
  genderChart: any = [];
  totalFunctionResultCount: number = 0;
  dropDownMenu: any = [];
  selectedFunction: any;
  genderChartByFunction: any;
  startIndexForDiversity: number = 0;
  previousDiversityData: any = [];
  previousDiverityFunctions: any[] = [];
  diversityTable: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['key', 'doc_count', 'male', 'graph', 'female'];
  @ViewChild(MatSort, { static: true }) diversityTbSort: MatSort;
  aggregatescount: number = 50;
  isViewMore: boolean = true;
  alternatecompanyNames: any[] = [];
  diversitysubscription: Subscription;
  diversitydata: any;
  functionsname: any;
  genderemptystate: Boolean = false;
  functiongenderemptystate: Boolean = false;
  functionemptystate: Boolean = false;
  diversitySortData:any = [];

    /** start index in page */
    start: number = 0;
    /**End index in page */
    end: number = 6;
    /**Number of items on each of page */
    pageSize:number = 6;
    /**Current page number */
    currentPage: number = 1;
    /**Total items */
    totalCount = 0;
    diversitydataAI: any = {}

      /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};

  insightsExportSubscription: Subscription = null;


  /**
 * Mapping of key and text value of headers
 * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
 */
  tableHeaderObj = {
    "Function": "Function",
    "TalentCount": "Talent Count",
    "Men": "Men",
    "GenderRatio": "Gender Ratio",
    "Women": "Women"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  /** Nationality chart */
  nationalityChart: any = [];

  /**Aggregate for nationality type is pending or not */
  isNationalityPending: boolean = false;

  /** Ethnicity chart */
  ethnicityChart : any = [];

  /**Aggregate for ethnicity type is pending or not */
  isEthnicityPending: boolean = false;
  filterData: any = {};

  ngOnInit(): void {
    this.start = 0;
    this.end = 6;
    this.currentPage = 1;
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      const extra = _methodDetails;
      this.filterData = this.filterDataHandlerService.fetchFilterData;
      this.fetchPageData()
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getGenderChart();
    this.getDropDownMenu();
    this.getDiversityChart();
    // this.getNationalityData();
    // this.getEthnicity();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  /**
 * Get Nationality data from aggregate and show fusion chart
 */
  getNationalityData() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "nationality";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.isNationalityPending = true;
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.isNationalityPending = false;
      const nationalityData = response?.data?.aggregations?.nationality || [];

      this.nationalityChart = this.fusionChartService.nationalityChart(nationalityData, response?.data?.totalresultscount);

      const nationalityDataAi = this.nationalityChart.data.map(x => ({
        key: x.label,
        doc_count: x.value + '%'
      }));


      this.getdiversitydataai(nationalityDataAi, 'nationality');
    })
  }

  /**
  * Get Ethnicity data from aggregate and show fusion chart
  */
  getEthnicity() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "ethnicity";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.isEthnicityPending = true;
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {

      this.isEthnicityPending = false;

      const ethnicityData = response?.data?.aggregations?.ethnicity || [];

      this.ethnicityChart = this.fusionChartService.ethnicityChart(ethnicityData, response?.data?.totalResultCount);
      const ethnicityDataAi = this.ethnicityChart.data.map(x => ({
        key: x.label,
        doc_count: x.value + '%'
      }));

      this.getdiversitydataai(ethnicityDataAi, 'ethnicity');
    })
  }

  getGenderChart() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      this.genderemptystate = true;
      const data = response.data.aggregations.gender;

      this.genderChart = this.fusionChartService.genderDiversityChart(data);
    });
  }


  getDropDownMenu() {

    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.dropDownMenu = response.data.aggregations['current_function'].map(x => x.key);
      this.selectedFunction = this.dropDownMenu[0];
      this.getGenderChartByFunction();
    });
  }

  filterselected(event) {
    this.selectedFunction = event.target.value;
    this.genderChartByFunction.data = [];
    this.getGenderChartByFunction();
  }

  getGenderChartByFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    aggReq.functions = [this.selectedFunction];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const totalCount = response.data.totalresultscount;
      this.functiongenderemptystate = true;
      const data = response.data.aggregations.gender;
      const ChartForGender = [];
      // let unknownGender = 0
      // if (data.length > 1) {
      //   unknownGender = totalCount - data[0].doc_count - data[1].doc_count;
      // } else if (data.length == 1) {
      //   unknownGender = totalCount - data[0].doc_count;
      // } else if (!data.length) {
      //   unknownGender = totalCount;
      // }
      // if (unknownGender) {
      //   data.push({
      //     key: "Not Known",
      //     doc_count: unknownGender,
      //   })
      // }
      this.genderChartByFunction = this.fusionChartService.genderDiversityChart(data);
    });
  }

  /**
   * Sort the array
   */
  manualSort() {
    this.reSortArray(this.diversityTbSort);
  }

  /**
   * Re-sort the array
   * @param {MatSort} sort
   */
  private reSortArray(sort: MatSort) {
    const data = this.diversitySortData;
    if (!sort || !sort.active || sort.direction === '') {
      this.diversitydata = data.slice(this.start, this.end);
      this.diversityTable = new MatTableDataSource(this.diversitydata);
      this.diversityTable.sort = this.diversityTbSort;
      return;
    }
     const tempData = this.diversitySortData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'male': return this.compare(a.male, b.male, isAsc);
        case 'female': return this.compare(a.female, b.female, isAsc);
        default: return 0;
      }
    });

    this.diversitydata = tempData.slice(this.start, this.end);
    this.diversityTable = new MatTableDataSource(this.diversitydata);
    this.diversityTable.sort = this.diversityTbSort;
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


  async getDiversityChart() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe(async (response) => {
      const tempData = response.data.aggregations['current_function'];
      // const previousDiverityFunctionsLength = this.previousDiverityFunctions.length;
      // this.previousDiverityFunctions = this.previousDiverityFunctions.concat(tempData.slice(previousDiverityFunctionsLength, this.aggregatescount));
      // const functionArray = this.previousDiverityFunctions.map(x => x.key).slice(previousDiverityFunctionsLength, this.aggregatescount);
      // if(tempData.length < this.aggregatescount + 1) {
      //   this.isViewMore = false;
      // }
     // await this.processArrayWithForLoop(functionArray);

     this.totalCount = tempData.length;

      this.diversitySortData = tempData;
      this.diversitydata = tempData.slice(this.start, this.end);
      this.functionsname = _.pluck(this.diversitySortData, 'key');
      this.diversityTable = new MatTableDataSource(this.diversitydata);
      this.diversityTable.sort = this.diversityTbSort;
      this.functionemptystate = true;
      this.getfunctiondiversityratio();
      this.manualSort();

    });
  }

  private getPercentage(value: number, total: number) {
    return ((value/total)*100).toFixed(2);
  }

  getfunctiondiversityratio() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function-gender";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['current_function-gender'];
      this.diversitySortData.map(res=>{
        const gender = tempData.filter(x=>x.key.toLowerCase().trim() === res.key.toLowerCase().trim())[0];
        if(gender && gender.gender && gender.gender.length > 0) {
          const femalecount = gender.gender.filter(x=>x.key == "female") && gender.gender.filter(x=>x.key == "female").length > 0 ? gender.gender.filter(x=>x.key == "female")[0].doc_count: 0;
          const malecount = gender.gender.filter(x=>x.key == "male") && gender.gender.filter(x=>x.key == "male").length > 0 ? gender.gender.filter(x=>x.key == "male")[0].doc_count: 0;
          const totalgendercount = femalecount + malecount
          res.female = femalecount ? this.getdiversitypercentage(femalecount, totalgendercount): 0
          res.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount): 0;
        } else {
          res.female = null;
          res.male = null;
        }
        return res;
      })
      this.getdiversitydataai(this.diversitySortData)
  })
}

getdiversitypercentage(value, doc_count) {
  return ((value / doc_count) * 100).toFixed(2);
}


  /**
 * Function set the start and end of aggreggate data according to page number
 * @param index page number in pagination
 */
  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getDiversityChart();
    }
    else{
      this.manualSort();
    }
  }

  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'diversity') return;

    // gender diversity chart config
    const genderDiversityChart = { renderAt: 'genderDiversityChart', dataSource: __.cloneDeep({ ...this.genderChart }) };
    genderDiversityChart['type'] = genderDiversityChart['dataSource']['type'];
    genderDiversityChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    genderDiversityChart['dataSource']['chart']['showLabels'] = "1";
    genderDiversityChart['dataSource']['chart']['showValues'] = "1";
    delete genderDiversityChart?.['dataSource']?.['type'];
    delete genderDiversityChart?.['dataSource']?.['width'];
    delete genderDiversityChart?.['dataSource']?.['chart']?.['width'];
    delete genderDiversityChart?.['dataSource']?.['height'];
    delete genderDiversityChart?.['dataSource']?.['chart']?.['height'];
    delete genderDiversityChart?.['dataSource']?.['chart']?.['renderAt'];

    // gender diversity by function chart config
    const genderDiversityByFunctionChart = { renderAt: 'genderDiversityByFunctionChart', dataSource: __.cloneDeep({ ...this.genderChartByFunction }) };
    genderDiversityByFunctionChart['type'] = genderDiversityByFunctionChart['dataSource']['type'];
    genderDiversityByFunctionChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    genderDiversityByFunctionChart['dataSource']['chart']['showLabels'] = "1";
    genderDiversityByFunctionChart['dataSource']['chart']['showValues'] = "1";
    delete genderDiversityByFunctionChart?.['dataSource']?.['type'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['width'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['chart']?.['width'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['height'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['chart']?.['height'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['chart']?.['renderAt'];

    this.tableHeaderName = [this.tableHeaderObj['Function'], this.tableHeaderObj["TalentCount"], this.tableHeaderObj["Men"], this.tableHeaderObj["Women"]];
    // //Nationality chart config
    // const nationalityChart = { renderAt: 'nationalityChart', type: 'bar2d', dataSource: { ...this.nationalityChart } };
    // delete nationalityChart['dataSource']['tooltext'];

    // //Ethnicity chart config
    // const ethnicityChart = { renderAt: 'ethnicityChart', type: 'doughnut2d', dataSource: __.cloneDeep({ ...this.ethnicityChart }) };
    // delete ethnicityChart['dataSource']['tooltext'];
    // ethnicityChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    // ethnicityChart['dataSource']['chart']['showLabels'] = "1";
    // ethnicityChart['dataSource']['chart']['showValues'] = "1";

    const payloadForInsightsExport: ExportPayload = {
      tab: 'diversity',
      companydetails: this.companyDetails,
      totalresultcount: this.totalFunctionResultCount,
      chartdetails: [genderDiversityChart, genderDiversityByFunctionChart],
      selectedFunction: this.selectedFunction,
      diversityByFunction: this.diversitySortData,
      tableHeader: this.tableHeaderName
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
      const redirectFilters: Partial<FilterParams> = {
                    // Company context — always present
                    companyid: this.companyDetails?.id,
                    companyname: this.currentCompanyName,
                    alternativecompanynames: this.alternatecompanyNames,

                    // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
                    // sidebar). Nested so it can never collide with the listing page's normal filters.
                    insightsFilterData: this.filterData,
                  };
    switch(type) {
      case 'functions': redirectFilters['mandatoryfunctions'] = [key]; break;
    }

      const uniqueKey = this.hashService.generateUniqueHash();
         localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

         const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
         window.open(url, '_blank');
  }

  getdiversitydataai(data, type='') {
    if(type === ''){
      let diversitydata: any;
      diversitydata = data.map(x=>{
         let res: any ={};
         res['Function'] = x.key;
         res['Talent Count'] = x.doc_count;
         res['Men'] = x.male+'%';
         res['Women'] = x.female+'%';
         return res;
       })
       this.diversitydataAI['functions'] = diversitydata;
    } else if (type === 'nationality'){
      this.diversitydataAI['nationality'] = data;
    } else if(type === 'ethnicity'){
      this.diversitydataAI['ethnicity'] = data;
    }
  }
}
